import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './content-card.component.scss';
import Slider from '../slider/slider.component';
var ContentCard = /** @class */ (function (_super) {
    tslib_1.__extends(ContentCard, _super);
    function ContentCard(element) {
        return _super.call(this, element) || this;
    }
    ContentCard.prototype.init = function () {
        this.sliderContainer = this.element.querySelector('.swiper-container');
        this.sliderPagination = this.element.querySelector('.swiper-pagination');
        this.sliderNext = this.element.querySelector('.swiper-button-next');
        this.sliderPrev = this.element.querySelector('.swiper-button-prev');
        if (this.element.classList.contains('content-card--single')) {
            this.slidesPerColumn = 1;
        }
        else {
            this.slidesPerColumn = 2;
        }
        this.initSlider();
        if (this.slidesPerColumn > 1) {
            this.initAlternatingSlideStyles();
        }
    };
    ContentCard.prototype.bindEvents = function () { };
    ContentCard.prototype.setSliderConfig = function () {
        // old
        this.sliderConfig = {
            spaceBetween: 0,
            slidesPerView: 2,
            slidesPerColumn: this.slidesPerColumn,
            initialSlide: 0,
            breakpoints: {
                1023: {
                    spaceBetween: 0,
                    slidesPerView: 1,
                    slidesPerColumn: 2,
                    initialSlide: 0
                },
                767: {
                    spaceBetween: 20,
                    slidesPerView: 2.4,
                    slidesPerColumn: 1,
                    initialSlide: 0
                },
                576: {
                    spaceBetween: 15,
                    slidesPerView: 1.2,
                    slidesPerColumn: 1,
                    initialSlide: 0,
                }
            },
            pagination: {
                el: this.sliderPagination,
                type: 'bullets',
                clickable: true
            },
            navigation: {
                nextEl: this.sliderNext,
                prevEl: this.sliderPrev
            }
        };
        // new
        this.sliderConfigNew = {
            spaceBetween: 30,
            slidesPerView: 2,
            slidesPerColumn: this.slidesPerColumn,
            initialSlide: 0,
            breakpoints: {
                1023: {
                    spaceBetween: 15,
                    slidesPerView: 1,
                    slidesPerColumn: 2,
                    initialSlide: 0
                },
                767: {
                    spaceBetween: 20,
                    slidesPerView: 2.4,
                    slidesPerColumn: 1,
                    initialSlide: 0
                },
                576: {
                    spaceBetween: 15,
                    slidesPerView: 1.2,
                    slidesPerColumn: 1,
                    initialSlide: 0,
                }
            },
            pagination: {
                el: this.sliderPagination,
                type: 'bullets',
                clickable: true
            },
            navigation: {
                nextEl: this.sliderNext,
                prevEl: this.sliderPrev
            }
        };
    };
    ContentCard.prototype.initSlider = function () {
        this.setSliderConfig();
        if (this.element.classList.contains('content-card__new')) {
            Slider.init(this.sliderContainer, this.sliderConfigNew);
        }
        else {
            Slider.init(this.sliderContainer, this.sliderConfig);
        }
    };
    ContentCard.prototype.initAlternatingSlideStyles = function () {
        var items = Array.from(this.element.querySelectorAll('.js-content-card-item-container'));
        for (var i = 0; i < items.length; i++) {
            var itemParent = items[i].parentNode;
            if (itemParent.attributes[0].value.indexOf('swiper-alt') >= 0) {
                if (items[i].querySelector('.content-card-item__link')) {
                    items[i].querySelector('.content-card-item__link').classList.add('content-card-item__link--alt');
                }
                if (items[i].querySelector('.content-card-item__content')) {
                    items[i].querySelector('.content-card-item__content').classList.add('content-card-item__content--alt');
                }
                if (items[i].querySelector('.content-card-item__image-holder')) {
                    items[i].querySelector('.content-card-item__image-holder').classList.add('content-card-item__image-holder--alt');
                }
            }
        }
    };
    return ContentCard;
}(Base));
export { ContentCard };



//////////////////
// WEBPACK FOOTER
// ./components/content-card/content-card.component.ts
// module id = 217
// module chunks = 0